import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-0c117160"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flight-container" };
const _hoisted_2 = { class: "flight-container desktop" };
const _hoisted_3 = { id: "flight-identifier-container" };
const _hoisted_4 = { class: "grid-center" };
const _hoisted_5 = ["src"];
const _hoisted_6 = { id: "flight-general-info-container" };
const _hoisted_7 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_8 = { id: "flight-route-container" };
const _hoisted_9 = { class: "exo-font-white-small" };
const _hoisted_10 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_11 = { id: "flight-user-titles-container" };
const _hoisted_12 = { id: "flight-user-info-container" };
const _hoisted_13 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_14 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_15 = _withScopeId(() => _createElementVNode("hr", null, null, -1));
const _hoisted_16 = { id: "flight-actions-container" };
const _hoisted_17 = { id: "flight-last-updated" };
const _hoisted_18 = {
    class: "full-width grid-center",
    alt: "flight detail button"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Tuple = _resolveComponent("Tuple");
    const _component_StateSvg = _resolveComponent("StateSvg");
    const _component_FlightProgress = _resolveComponent("FlightProgress");
    const _component_StdLineChart = _resolveComponent("StdLineChart");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_Tuple, {
                    value: _ctx.callsign,
                    title: _ctx.aicraftLivery,
                    class: "grid-center"
                }, null, 8, ["value", "title"]),
                _createElementVNode("div", _hoisted_4, [
                    _createVNode(_component_StateSvg, {
                        class: "align-right absolute",
                        src: "svg/refresh.svg",
                        onClick: _ctx.onClickRefresh
                    }, null, 8, ["onClick"])
                ])
            ]),
            _createElementVNode("img", {
                src: _ctx.imageSrc,
                onerror: "if(this.src != 'img/404.webp') this.src='img/404.webp'",
                class: "full-width",
                alt: "aircraft image"
            }, null, 8, _hoisted_5),
            _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_Tuple, {
                    value: _ctx.speed,
                    title: "Speed",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.altitude,
                    title: "Altitude",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.verticalSpeed,
                    title: "VS",
                    class: "grid-center"
                }, null, 8, ["value"])
            ]),
            _hoisted_7,
            _createElementVNode("div", _hoisted_8, [
                _createVNode(_component_Tuple, {
                    value: _ctx.icaoDeparture,
                    title: _ctx.departureTime,
                    class: "flight-progress-airport"
                }, null, 8, ["value", "title"]),
                _createVNode(_component_FlightProgress, {
                    id: "flight-progress-bar",
                    progress: _ctx.flightProgress,
                    class: "margin-inline-1"
                }, null, 8, ["progress"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.icaoDestination,
                    title: _ctx.arrivalTime,
                    class: "flight-progress-airport align-right"
                }, null, 8, ["value", "title"])
            ]),
            _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.fpl), 1),
            _hoisted_10,
            _createElementVNode("div", _hoisted_11, [
                _createVNode(_component_Tuple, {
                    value: _ctx.username,
                    title: _ctx.userTitle
                }, null, 8, ["value", "title"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.grade,
                    title: "Grade",
                    class: "grid-center"
                }, null, 8, ["value"])
            ]),
            _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_Tuple, {
                    value: _ctx.xp,
                    title: "XP",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.virtualGroup,
                    title: "Virtual Group",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.flightTime,
                    title: "Flight Time",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.atcOps,
                    title: "ATC Ops",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.violationTotal,
                    title: "Σ Violations",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.landings,
                    title: "Landings",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.violation1,
                    title: "Violations 1",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.violation2,
                    title: "Violations 2",
                    class: "grid-center"
                }, null, 8, ["value"]),
                _createVNode(_component_Tuple, {
                    value: _ctx.violation3,
                    title: "Violations 3",
                    class: "grid-center"
                }, null, 8, ["value"])
            ]),
            _hoisted_13,
            _createVNode(_component_StdLineChart, {
                class: "flight-chart",
                title: "Altitude",
                data: _ctx.altitudes
            }, null, 8, ["data"]),
            _hoisted_14,
            _createVNode(_component_StdLineChart, {
                class: "flight-chart",
                title: "Speed",
                data: _ctx.speeds
            }, null, 8, ["data"]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_StateSvg, {
                    src: "svg/target_on.svg",
                    class: "flight-action",
                    onClick: _ctx.onClickTarget
                }, null, 8, ["onClick"]),
                _createVNode(_component_StateSvg, {
                    src: "svg/share.svg",
                    class: "flight-action",
                    onClick: _ctx.onClickShare
                }, null, 8, ["onClick"]),
                _createVNode(_component_StateSvg, {
                    src: "svg/download.svg",
                    class: "flight-action",
                    onClick: _ctx.onClickDownload
                }, null, 8, ["onClick"])
            ]),
            _createElementVNode("p", _hoisted_17, " Time Report : " + _toDisplayString(_ctx.lastUpdated), 1)
        ]),
        _createElementVNode("div", {
            class: "flight-container mobile clickable",
            onClick: _cache[0] || (_cache[0] =
                (...args) => (_ctx.onFullScreen && _ctx.onFullScreen(...args)))
        }, [
            _createElementVNode("button", _hoisted_18, [
                _createVNode(_component_Tuple, {
                    value: _ctx.callsign,
                    title: _ctx.aicraftLivery,
                    class: "grid-center"
                }, null, 8, ["value", "title"])
            ])
        ])
    ]));
}
